function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m24.104 23.766h464.17v318.638h-464.17z",
  fill: "#fff4f4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m257.955 23.766h230.319v318.638h-230.319z",
  fill: "#f6efea"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m386.955 482h-19.701s-19.561-51.947-22.313-59.274c-2.198-5.85-7.792-9.725-14.042-9.725h-150c-6.25 0-11.844 3.875-14.042 9.725-4.317 11.498-22.291 59.274-22.291 59.274h-19.701c-8.284 0-15 6.716-15 15s6.716 15 15 15h262.09c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
  fill: "#00607f"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m386.955 482h-19.701s-19.561-51.947-22.313-59.274c-2.198-5.85-7.792-9.725-14.042-9.725h-72.945v98.999h129c8.284 0 15-6.716 15-15s-6.715-15-14.999-15z",
  fill: "#002c3c"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m497 0h-482c-8.284 0-15 6.716-15 15v390.967c0 8.284 6.716 15 15 15h128.357l15.536 17.116c2.843 3.132 6.877 4.918 11.107 4.918h172c4.23 0 8.264-1.786 11.107-4.919l15.536-17.115h128.357c8.284 0 15-6.716 15-15v-390.967c0-8.284-6.716-15-15-15zm-15 30v300.966h-452v-300.966z",
  fill: "#00cef5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m497 0h-239.045v30h224.045v300.966h-224.045v112.035h84.045c4.23 0 8.264-1.786 11.107-4.919l15.536-17.115h128.357c8.284 0 15-6.716 15-15v-390.967c0-8.284-6.716-15-15-15z",
  fill: "#0095ff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m194.955 120.001h-5.933c-1.236-4.45-3.007-8.678-5.24-12.613l4.208-4.208c5.857-5.858 5.857-15.355 0-21.213-5.858-5.859-15.355-5.857-21.213 0l-4.207 4.207c-3.935-2.234-8.162-4.004-12.613-5.241v-5.933c0-8.284-6.716-15-15-15s-15 6.716-15 15v5.933c-4.45 1.236-8.678 3.007-12.613 5.241l-4.207-4.207c-5.857-5.859-15.355-5.857-21.213 0s-5.858 15.354 0 21.213l4.207 4.207c-2.234 3.935-4.004 8.162-5.241 12.613h-5.933c-8.284 0-15 6.716-15 15s6.716 15 15 15h5.933c1.236 4.45 3.007 8.677 5.24 12.612l-4.207 4.207c-5.857 5.858-5.857 15.355 0 21.213 2.929 2.93 6.768 4.394 10.606 4.394s7.678-1.465 10.607-4.394l4.207-4.207c3.935 2.234 8.162 4.004 12.613 5.241v5.934c0 8.284 6.716 15 15 15s15-6.716 15-15v-5.933c4.45-1.236 8.678-3.007 12.613-5.241l4.207 4.207c2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.465 10.606-4.394c5.858-5.857 5.858-15.355 0-21.213l-4.207-4.207c2.234-3.935 4.004-8.162 5.241-12.612h5.933c8.284 0 15-6.716 15-15s-6.716-15-15-15zm-60 41.118c-14.402 0-26.119-11.717-26.119-26.118 0-14.402 11.717-26.119 26.119-26.119 14.401 0 26.118 11.717 26.118 26.119 0 14.401-11.717 26.118-26.118 26.118z",
  fill: "#007a9f"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m257.955 210c-8.284 0-15-6.716-15-15v-120c0-8.284 6.716-15 15-15s15 6.716 15 15v120c0 8.284-6.716 15-15 15z",
  fill: "#7d0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m315.956 210c-8.284 0-15-6.716-15-15v-61c0-8.284 6.716-15 15-15s15 6.716 15 15v61c0 8.284-6.716 15-15 15z",
  fill: "#c30048"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m375.956 210c-8.284 0-15-6.716-15-15v-117.308c0-8.284 6.716-15 15-15s15 6.716 15 15v117.308c0 8.284-6.716 15-15 15z",
  fill: "#00ab5e"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m435.956 210c-8.284 0-15-6.716-15-15v-57.48c0-8.284 6.716-15 15-15s15 6.716 15 15v57.48c0 8.284-6.716 15-15 15z",
  fill: "#c30048"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m365.976 256.001h-65.02c-8.284 0-15 6.716-15 15s6.716 15 15 15h65.02z",
  fill: "#00ab5e"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m420.955 256.001h-50v30h50c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
  fill: "#e0d2cd"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m370.956 307.001c-8.284 0-15-6.716-15-15v-42c0-8.284 6.716-15 15-15s15 6.716 15 15v42c0 8.284-6.716 15-15 15z",
  fill: "#00607f"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m124.189 256.001h-33.234c-8.284 0-15 6.716-15 15s6.716 15 15 15h33.234z",
  fill: "#7d0"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m210.954 256.001h-78.084v30h78.084c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
  fill: "#eee1dc"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m128.956 307.001c-8.284 0-15-6.716-15-15v-42c0-8.284 6.716-15 15-15s15 6.716 15 15v42c0 8.284-6.716 15-15 15z",
  fill: "#007a9f"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m257.955 60v150c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15z",
  fill: "#00ab5e"
});

var Svg036Analysis = function Svg036Analysis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg036Analysis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/036-analysis.f550cb81.svg";
export { ForwardRef as ReactComponent };